import ApiService from '../ApiService';
const { REACT_APP_REST_ENDPOINT } = process.env;

export default class EsamiUtentiService {
  
  static getEsamiUtentiByIdEsame = (idEsame) => {
    return new Promise((resolve, reject) => { 
      let url = `${REACT_APP_REST_ENDPOINT}/esami-utenti/findByIdCalendarioEsame`;
      return ApiService.postRequest(resolve, reject, url, idEsame);
    })
  };

  static getEsamiUtentiByIdClasseUtente = (idClasseUtente) => {
    return new Promise((resolve, reject) => { 
      let url = `${REACT_APP_REST_ENDPOINT}/esami-utenti/findByIdClasseUtente`;
      return ApiService.postRequest(resolve, reject, url, idClasseUtente);
    })
  }
  
  static prenotaEsameCorsoSincrono = (data) => {
    return new Promise((resolve, reject) => { 
      let url = `${REACT_APP_REST_ENDPOINT}/esami-utenti/prenotaEsameCorsoSincrono`;
      return ApiService.postRequest(resolve, reject, url, data);
    })
  };

  static prenotaEsameCorsoAsincrono = (data) => {
    return new Promise((resolve, reject) => { 
      let url = `${REACT_APP_REST_ENDPOINT}/esami-utenti/prenotaEsameCorsoAsincrono`;
      return ApiService.postRequest(resolve, reject, url, data);
    })
  };
  
  static getEsameUtenteById = (id) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/esami-utenti/show`;
      ApiService.getRequest(resolve, reject, url, id);
    });
  };

  static createEsameUtente = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/esami-utenti/create`;
      ApiService.postRequest(resolve, reject, url, data);
    });
  };

  static deleteEsameUtente = (id) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/esami-utenti/delete`;
      ApiService.delete(resolve, reject, url, id);
    });
  };

  static updateEsameUtente = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/esami-utenti/update`;
      ApiService.putRequest(resolve, reject, url, data);
    });
  };

  static enterJoinroomCorsista = (data) => {//NEW
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/esami-utenti/enterJoinroomCorsista`;
      ApiService.postRequest(resolve, reject, url, data);
    });
  };

  static enterJoinroomAdmin = (data) => {//NEW
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/esami-utenti/enterJoinroomAdmin`;
      ApiService.postRequest(resolve, reject, url, data);
    });
  };

  static uploadStatino = (formData) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/esami-utenti/uploadStatino`;
      ApiService.postFormData(url, formData)
        .then(resolve)
        .catch(error => {
          console.error('Errore nel servizio EsamiUtentiService:', error);
          reject(error);
        });
    });
  };

  static removeStatino = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/esami-utenti/removeStatino`;
      ApiService.delete(resolve, reject, url, data);
    });
  };

  static updateEsameUtentiResults = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/esami-utenti/updateEsitiEsami`;
      ApiService.postRequest(resolve, reject, url, data);
    });
  };

  static downloadStatino = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/esami-utenti/downloadStatino`;
      ApiService.postRequestWithDownload(resolve, reject, url, data);
    });
  };

}

